<template src="../templates/normal_fcont_180.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink';
import PrintButton from '../components/PrintButton'
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import { mapState, mapGetters } from "vuex";
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,
    PrintButton,InfoMachineTranslation
  },
  computed: {
  ...mapState(["os"]),
  ...mapGetters(["isWwTemplate"]),
  isPc: function () {
    return this.os == "ws" || this.os == "mi";
  },
  supportTemplate: function() {
    if (this.isPc && this.isWwTemplate){
      // Photo＋の「アルバム」サブカテゴリが国内のみサポートのため
      return false
    }
    return true
  }
},
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['180-1'],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['180-3']}
      ]
    };
  }
  
};
</script>
<style scoped>
</style>

